import { TransactionType } from '@msafe/sui3-utils';
import { Transaction } from '@mysten/sui/transactions';
import { WalletAccount } from '@mysten/wallet-standard';

import { BaseIntention } from '@/apps/interface/sui';
import { SuiClient } from '@/compat/mysten-sui-json-rpc';

import TxBuilder from '../tx-builder';
import { SuiNetworks, TransactionSubType, BluefinIntentionData, CollectRewardsAndFeeIntentionData } from '../types';

export class CollectRewardsAndFee extends BaseIntention<BluefinIntentionData> {
  txType = TransactionType.Other;

  txSubType = TransactionSubType.CollectRewardsAndFee;

  constructor(public readonly data: BluefinIntentionData) {
    super(data);
  }

  async build(input: { network: SuiNetworks; suiClient: SuiClient; account: WalletAccount }): Promise<Transaction> {
    const { account, network } = input;
    console.log(this.data);
    return TxBuilder.collectRewardsAndFee(this.data as CollectRewardsAndFeeIntentionData, account, network);
  }

  static fromData(data: BluefinIntentionData) {
    return new CollectRewardsAndFee(data);
  }
}
